import React from 'react';
import PropTypes from 'prop-types';

export class SelectPlan extends React.Component {

    getPlanType(src) {
        let showMixedInstallments = (src.isDeferred && src.hasRemainingInstalments) || (src.hasInterestFreeInstalments && !src.hasRemainingInstalments) || (!src.hasInterestFreeInstalments && src.hasRemainingInstalments && src.deferredInstalmentTimes === 0) || (src.hasInterestFreeInstalments && src.hasRemainingInstalments);
        let showDeferredPeriod = src.isDeferred && src.hasRemainingInstalments;
        let isBNPL = src.isDeferred && src.hasInterestFreeInstalments;
        let showInterestFreeOnly = src.hasInterestFreeInstalments && !src.hasRemainingInstalments;
        let showInterestBearingOnly = !src.hasInterestFreeInstalments && src.hasRemainingInstalments && src.deferredInstalmentTimes === 0
        let showMixedInterest = src.hasInterestFreeInstalments && src.hasRemainingInstalments;
        let showInterestBearingInstallments = showDeferredPeriod || showInterestBearingOnly || showMixedInterest;
        let showInterestFreeInstallments = showInterestFreeOnly || showMixedInterest || isBNPL;
        return {
            showDeferredPeriod,
            isBNPL,
            showInterestFreeOnly,
            showInterestBearingOnly,
            showMixedInterest,
            showMixedInstallments,
            showInterestBearingInstallments,
            showInterestFreeInstallments
        };
    }

    renderUnselectedPlanCard = (props) => {
        let { src, quoteResult, selectedPlanInterval, selectIndividualPlan } = props;

        let currentRetailerPlan = quoteResult?.data?.retailer_plan?.find(
            (p) => p.retailerplan_id === src.plan_id
        );

        let isIntervalActive =
            !selectedPlanInterval ||
            currentRetailerPlan?.term !== selectedPlanInterval;

        let handleSelect = () => {
            if (isIntervalActive) {
                selectIndividualPlan(src, currentRetailerPlan, quoteResult);
            }
        };

        return (
            <div className="col-12 col-sm-6 col-md-6 col-lg-4" key={src.plan_id}>
                <button
                    className={`individual-plan text-center ${isIntervalActive ? 'active-plan' : 'disabled-plan'}`}
                    tabIndex={0}
                    onClick={handleSelect}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            handleSelect();
                        }
                    }}
                >
                    <p className="plan-overview">{src.planName}</p>

                    <div className="plan-row d-flex justify-content-center">
                        <div className="plan-col plan"><p className="amount-description plan">Upfront Instalment</p></div>
                        <div className="plan-col plan"><p className="amount-description plan">Monthly Repayment</p></div>
                        <div className="plan-col plan"><p className="amount-description plan">Interest Rate</p></div>
                    </div>

                    <div className="plan-row d-flex justify-content-center">
                        <div className="plan-col plan"><p className="amount-value plan">£{Number(src.totalUpfrontInstallment || 0).toFixed(2)}</p></div>
                        <div className="plan-col plan"><p className="amount-value plan">£{Number(src.installmentAmount || 0).toFixed(2)}</p></div>
                        <div className="plan-col plan"><p className="amount-value plan">{Number(src.interestRate || 0).toFixed(2)}%</p></div>
                    </div>

                    <p className="footer-section">Select Plan</p>
                </button>
            </div>
        );
    };

    renderSelectedPlanCard = ({ src, planTypes }) => {
        const {
            showMixedInstallments,
            showDeferredPeriod,
            isBNPL,
            showInterestFreeOnly,
            showInterestBearingOnly,
            showMixedInterest,
            showInterestBearingInstallments,
            showInterestFreeInstallments
        } = planTypes;

        const hasUpfrontFees = Number(src.totalUpfrontInstallment || 0) > 0;

        return (
            <div className="col-12 col-sm-6 col-md-6 col-lg-4" key={src.plan_id}>
                <div className="individual-selected-plan text-center">
                    <p className="plan-overview-selected">Selected</p>
                    <p className="plan-overview plan-name">{src.planName}</p>

                    <div className="plan-details">
                        <div className="plan-row d-flex justify-content-center">
                            <div className="plan-col"><p className="amount-description">Upfront Payment</p></div>
                            <div className="plan-col"><p className="amount-description">Monthly Repayment</p></div>
                            <div className="plan-col"><p className="amount-description">Interest Rate</p></div>
                        </div>

                        <div className="plan-row d-flex justify-content-center">
                            <div className="plan-col">
                                <p className="amount-value">£{Number(src.totalUpfrontInstallment || 0).toFixed(2)}</p>
                            </div>
                            <div className="plan-col">
                                <p className="amount-value">£{Number(src.installmentAmount || 0).toFixed(2)}</p>
                            </div>
                            <div className="plan-col">
                                <p className="amount-value">{Number(src.interestRate || 0).toFixed(2)}%</p>
                            </div>
                        </div>
                    </div>

                    <div className="additonal-plan-details text-left">
                        {hasUpfrontFees && (
                            <div className="upfront-amount-details">
                                <p className="summary-title">Upfront</p>
                                <div className="upfront-amount-description">
                                    <div className="plan-row d-flex justify-content-center">
                                        <div className="plan-col plan-label"><p className="amount-description">Application Fee</p></div>
                                        <div className="plan-col plan-currency"><p className="amount-description">£</p></div>
                                        <div className="plan-col plan-amount"><p className="amount-description">{Number(src.setUpFee || 0).toFixed(2)}</p></div>
                                    </div>
                                    <div className="plan-row d-flex justify-content-center">
                                        <div className="plan-col plan-label"><p className="amount-description">Upfront Instalment</p></div>
                                        <div className="plan-col plan-currency"><p className="amount-description">£</p></div>
                                        <div className="plan-col plan-amount"><p className="amount-description">{Number(src.upfrontInstallment || 0).toFixed(2)}</p></div>
                                    </div>
                                    <div className="plan-row d-flex justify-content-center">
                                        <div className="plan-col plan-label"><p className="amount-description">Total Upfront Payment</p></div>
                                        <div className="plan-col plan-currency"><p className="amount-description">£</p></div>
                                        <div className="plan-col plan-amount"><p className="amount-description">{Number(src.totalUpfrontInstallment || 0).toFixed(2)}</p></div>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="installment-payment-deatils">
                            <p className="summary-title">Instalments</p>
                            <div className="upfront-amount-description">
                                {showMixedInstallments && (
                                    <React.Fragment>
                                        <div className="plan-row d-flex justify-content-center interest-mixed-installments">
                                            <div className="plan-col plan-label label-interest-mixed-installments">
                                                <p className="amount-description amount-description-mixed-installments">Frequency</p>
                                            </div>
                                            <div className="plan-col plan-currency"><p className="amount-description"></p></div>
                                            <div className="plan-col plan-amount amount-interest-mixed-installments">
                                                <p className="amount-description amount-description-mixed-installments">{src.frequency}</p>
                                            </div>
                                        </div>

                                        <div className="plan-row d-flex justify-content-center interest-mixed-installments">
                                            <div className="plan-col plan-label label-interest-mixed-installments">
                                                <p className="amount-description amount-description-mixed-installments">Total Monthly Instalments</p>
                                            </div>
                                            <div className="plan-col plan-currency"><p className="amount-description"></p></div>
                                            <div className="plan-col plan-amount amount-interest-mixed-installments">
                                                {(showDeferredPeriod || showInterestBearingOnly) && (
                                                    <p className="amount-description">{src.remainingInstalmentTimes}</p>
                                                )}
                                                {(showInterestFreeOnly || isBNPL) && (
                                                    <p className="amount-description amount-description-no-interest">{src.interestFreeInstalmentTimes}</p>
                                                )}
                                                {showMixedInterest && (
                                                    <p className="amount-description amount-description-mixed-installments">
                                                        {Number(src.remainingInstalmentTimes || 0) + Number(src.interestFreeInstalmentTimes || 0)}
                                                    </p>
                                                )}
                                            </div>
                                        </div>

                                        {Number(src.monthlyFee || 0) > 0 && (
                                            <div className="plan-row d-flex justify-content-center interest-mixed-installments">
                                                <div className="plan-col plan-label label-interest-mixed-installments">
                                                    <p className="amount-description amount-description-mixed-installments">Account Keeping Fee</p>
                                                </div>
                                                <div className="plan-col plan-currency">
                                                    <p className="amount-description amount-description-mixed-installments">{src.installmentPeriod} x £</p>
                                                </div>
                                                <div className="plan-col plan-amount amount-interest-mixed-installments">
                                                    <p className="amount-description amount-description-mixed-installments">{Number(src.monthlyFee || 0).toFixed(2)}</p>
                                                </div>
                                            </div>
                                        )}
                                    </React.Fragment>
                                )}

                                {(showDeferredPeriod || isBNPL) && (
                                    <div className="plan-row d-flex justify-content-center">
                                        <div className="plan-col plan-label"><p className="amount-description">Deferred Period</p></div>
                                        <div className="plan-col plan-currency"><p className="amount-description"></p></div>
                                        <div className="plan-col plan-amount"><p className="amount-description">{src.deferredInstalmentTimes}</p></div>
                                    </div>
                                )}

                                {showInterestFreeInstallments && (
                                    <div className="plan-row d-flex justify-content-center interest-mixed-installments">
                                        <div className="plan-col plan-label label-interest-mixed-installments">
                                            <p className="amount-description amount-description-mixed-installments">Interest Free Instalments</p>
                                        </div>
                                        <div className="plan-col plan-currency">
                                            <p className="amount-description amount-description-mixed-installments">{src.interestFreeInstalmentTimes} x £</p>
                                        </div>
                                        <div className="plan-col plan-amount amount-interest-mixed-installments">
                                            <p className="amount-description amount-description-mixed-installments">{Number(src.interestFreeInstalmentAmount || 0).toFixed(2)}</p>
                                        </div>
                                    </div>
                                )}

                                {showInterestBearingInstallments && (
                                    <div className="plan-row d-flex justify-content-center interest-mixed-installments">
                                        <div className="plan-col plan-label label-interest-mixed-installments">
                                            <p className="amount-description amount-description-mixed-installments">Interest Bearing Instalments</p>
                                        </div>
                                        <div className="plan-col plan-currency">
                                            <p className="amount-description amount-description-mixed-installments">{src.remainingInstalmentTimes} x £</p>
                                        </div>
                                        <div className="plan-col plan-amount">
                                            <p className="amount-description amount-description-mixed-installments">{Number(src.remainingInstalmentAmount || 0).toFixed(2)}</p>
                                        </div>
                                    </div>
                                )}

                                {showMixedInstallments && (
                                    <div className="plan-row d-flex justify-content-center interest-mixed-installments">
                                        <div className="plan-col plan-label label-interest-mixed-installments">
                                            <p className="amount-description amount-description-mixed-installments">Total Amount Payable*</p>
                                        </div>
                                        <div className="plan-col plan-currency"><p className="amount-description amount-description-mixed-installments">£</p></div>
                                        <div className="plan-col plan-amount amount-interest-mixed-installments">
                                            <p className="amount-description amount-description-mixed-installments">{Number(src.totalAmountPayable || 0).toFixed(2)}</p>
                                        </div>
                                    </div>
                                )}

                                <div className="plan-row d-flex justify-content-center interest-mixed-installments">
                                    <div className="plan-col text-center label-interest-mixed-installments">
                                        <p className="amount-description text-center amount-description-mixed-installments late-fee ">Please note a £7.00 late fee applies where instalments are not made on the agreed date.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="additional-installment-details">
                            <div className="upfront-amount-description">
                                <div className="plan-row d-flex justify-content-center">
                                    <div className="plan-col plan-label">
                                        <p className="amount-description">Interest Rate</p>
                                    </div>
                                    <div className="plan-col plan-currency">
                                        <p className="amount-description">%</p>
                                    </div>
                                    <div className="plan-col plan-amount">
                                        <p className="amount-description">{Number(src.interestRate).toFixed(2)}</p>
                                    </div>
                                </div>
                                <div className="plan-row d-flex justify-content-center">
                                    <div className="plan-col plan-label">
                                        <p className="amount-description">{src.apr > 0 ? 'APR*' : 'APR'}</p>
                                    </div>
                                    <div className="plan-col plan-currency">
                                        <p className="amount-description">%</p>
                                    </div>
                                    <div className="plan-col plan-amount">
                                        <p className="amount-description">{Number(src.apr).toFixed(2)}</p>
                                    </div>
                                </div>
                                <div className="plan-row d-flex justify-content-center">
                                    <div className="plan-col plan-label">
                                        <p className="amount-description">* Includes interest of</p>
                                    </div>
                                    <div className="plan-col plan-currency">
                                        <p className="amount-description">£</p>
                                    </div>
                                    <div className="plan-col plan-amount">
                                        <p className="amount-description">{Number(src.totalInterest).toFixed(2)}</p>
                                    </div>
                                </div>
                                {src.totalFees > 0 && (
                                    <div className="plan-row d-flex justify-content-center">
                                        <div className="plan-col plan-label">
                                            <p className="amount-description">* Includes known Fees of</p>
                                        </div>
                                        <div className="plan-col plan-currency">
                                            <p className="amount-description">£</p>
                                        </div>
                                        <div className="plan-col plan-amount">
                                            <p className="amount-description">{Number(src.totalFees).toFixed(2)}</p>
                                        </div>
                                    </div>
                                )}
                                <div>
                                    {src.deferredInstalmentTimes > 0 && <p className='deferred-text'>{`Please note that repayments will begin after a ${src.deferredInstalmentTimes}\u2011month deferral period. Interest will accrue from the date the funds are advanced; however, if you repay the loan in full during the deferral period, all interest will be waived.`}</p>}
                                </div>
                                {src.totalFees > 0 && (
                                    <div>
                                        <p className="quote-text">*The Annual Percentage Rate (APR) is higher than the interest rate because it includes both the interest charged and any applicable fees.</p>
                                    </div>
                                )}

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    };

    renderPlanList = (plans = []) => {
        const {
            selectedPlanId,
            isApplicationNormalFlow,
            planNotSelectedByDefault,
            isplanSelected,
            quoteResult,
            selectedPlanInterval,
            selectIndividualPlan
        } = this.props;

        return plans.map((src) => {
            const { plan_id: planId } = src;
            const isPlanIdMatch = selectedPlanId === planId;
            const isSelected = isplanSelected && isPlanIdMatch;

            const isUnselectedVisible = !isPlanIdMatch && (
                isApplicationNormalFlow || !planNotSelectedByDefault
            );

            const planTypes = this.getPlanType(src);

            return (
                <React.Fragment key={planId}>
                    {isUnselectedVisible &&
                        this.renderUnselectedPlanCard({
                            src,
                            planTypes,
                            quoteResult,
                            selectedPlanInterval,
                            selectIndividualPlan
                        })}
                    {isSelected && this.renderSelectedPlanCard({ src, planTypes })}
                </React.Fragment>
            );
        });
    };

    render() {
        const { quoteResult, planNotSelectedByDefault } = this.props;
        const pcaData = quoteResult?.pca || quoteResult?.data?.pca || quoteResult || {};
        const standardPlans = pcaData.standard_plan || [];
        const deferredPlans = pcaData.deferred_plan || [];
        const allPcaPlans = [
            ...(pcaData.standard_plan || []),
            ...(pcaData.deferred_plan || [])
        ];
        
        if (allPcaPlans.length == 1 || planNotSelectedByDefault) {
            return (
                <div className="row">
                    {this.renderPlanList(allPcaPlans)}
                </div>
            );
        }

        return (
            <React.Fragment>
                {standardPlans.length > 0 && (
                    <React.Fragment>
                        <div className="px-0 plan-section-header my-3">
                            <h3 className="section-title-plan">Standard repayment plans</h3>
                        </div>
                        <div className="row">
                            {this.renderPlanList(standardPlans)}
                        </div>
                    </React.Fragment>
                )}

                {standardPlans.length > 0 && deferredPlans.length > 0 && (
                    <div className="my-4 text-center">
                        <hr
                            style={{
                                border: 'none',
                                borderTop: '3px solid #FE6200',
                                width: '100%',
                                margin: '2rem 0'
                            }}
                        />
                    </div>
                )}

                {deferredPlans.length > 0 && (
                    <React.Fragment>
                        <div className="px-0 plan-section-header my-3">
                            <h3 className="section-title-plan">Buy Now, Pay Later: <span className="title-break">Deferred repayment plans</span></h3>
                        </div>
                        <div className="row">
                            {this.renderPlanList(deferredPlans)}
                        </div>
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}

SelectPlan.propTypes = {
    quoteResult: PropTypes.any,
    selectIndividualPlan: PropTypes.func,
    selectedPlanId: PropTypes.any,
    isApplicationNormalFlow: PropTypes.bool,
    planNotSelectedByDefault: PropTypes.bool,
    selectedPlanInterval: PropTypes.any,
    isplanSelected: PropTypes.bool
}